import Vue from 'vue';
import utils from '../../../helpers/utils';

const feedMutations = (module) => {
    return {
        setResponse(state, data) {
            let repositoryName = data.repositoryName ? data.repositoryName : state.repositoryName;

            let feedPrefix = utils.capitalizeFirstOnlyLetter(repositoryName.replace('Feeds', ''));
            let feedTeam = repositoryName.replace('Feeds', '') + 'FeedTeam';

            if ('init' in data.response) {
                //need to reset feedLeague and feedTeam
                this.commit(module + '/set' + feedPrefix + 'FeedLeague', {});
                this.commit(module + '/set' + feedPrefix + 'FeedTeam', {});

                Object.entries(data.response.init).forEach(([, lineInit]) => {
                    if (lineInit.line === 1) {
                        this.commit(module + '/addFeedLeague', {
                            line: lineInit,
                            feedPrefix: feedPrefix,
                        });

                        if (!(lineInit.cthId in state[feedTeam])) {
                            this.commit(module + '/addFeedTeam', {
                                id: lineInit.cthId,
                                name: lineInit.cthName,
                                feedPrefix: feedPrefix,
                            });
                        }

                        if (!(lineInit.ctaId in state[feedTeam])) {
                            this.commit(module + '/addFeedTeam', {
                                id: lineInit.ctaId,
                                name: lineInit.ctaName,
                                feedPrefix: feedPrefix,
                            });
                        }
                    }
                });

                state[repositoryName] = data.response.init;
            } else {
                if ('update' in data.response) {
                    Object.entries(data.response.update).forEach(([key, lineUpdate]) => {
                        const [customEventIds, line] = key.split('|');
                        /*if (!state.gamesIdx[repositoryName]) {
                            //we can get old response after change page
                            console.log('Repository: ' + repositoryName);
                            console.log('CustomEventIds: ' + customEventIds);
                            console.log('Line: ' + line);
                            return;
                        }*/
                        const position = parseInt(state.gamesIdx[repositoryName][customEventIds]) + parseInt(line) - 1;
                        let lineNeedUpdate = state[repositoryName][position];

                        if (line === '1') {
                            if (lineUpdate.clId) {
                                this.commit(module + '/removeFeedLeague', {
                                    clId: lineNeedUpdate.clId,
                                    feedPrefix: feedPrefix,
                                });
                                this.commit(module + '/addFeedLeague', {
                                    line: lineUpdate,
                                    feedPrefix: feedPrefix,
                                });
                            }

                            if (lineUpdate.cthId && !(lineUpdate.cthId in state[feedTeam])) {
                                this.commit(module + '/addFeedTeam', {
                                    id: lineUpdate.cthId,
                                    name: lineUpdate.cthName,
                                    feedPrefix: feedPrefix,
                                });
                            }

                            if (lineUpdate.ctaId && !(lineUpdate.ctaId in state[feedTeam])) {
                                this.commit(module + '/addFeedTeam', {
                                    id: lineUpdate.ctaId,
                                    name: lineUpdate.ctaName,
                                    feedPrefix: feedPrefix,
                                });
                            }
                        }

                        const newRow = Object.assign({}, lineNeedUpdate, lineUpdate);
                        Vue.set(state[repositoryName], position, newRow);
                    });
                }

                if ('delete' in data.response) {
                    let removed = 0;
                    data.response.delete.forEach((value) => {
                        const [customEventIds, line] = value.split('|');
                        /*if (!state.gamesIdx[repositoryName]) {
                            //we can get old response after change page
                            console.log('Repository: ' + repositoryName);
                            console.log('CustomEventIds: ' + customEventIds);
                            console.log('Line: ' + line);
                            return;
                        }*/
                        const position = parseInt(state.gamesIdx[repositoryName][customEventIds]) + parseInt(line) - 1 - removed;
                        let lineDelete = state[repositoryName][position];

                        if (line === '1') {
                            if (lineDelete.clId) {
                                this.commit(module + '/removeFeedLeague', {
                                    clId: lineDelete.clId,
                                    feedPrefix: feedPrefix,
                                });
                            }

                            if (lineDelete.cthId && !(lineDelete.cthId in state[feedTeam])) {
                                this.commit(module + '/removeFeedTeam', {
                                    ctId: lineDelete.cthId,
                                    feedPrefix: feedPrefix,
                                });
                            }

                            if (lineDelete.ctaId && !(lineDelete.ctaId in state[feedTeam])) {
                                this.commit(module + '/removeFeedTeam', {
                                    ctId: lineDelete.ctaId,
                                    feedPrefix: feedPrefix,
                                });
                            }
                        }

                        Vue.delete(state[repositoryName], position);
                        removed++;
                    });
                }

                if ('insert' in data.response) {
                    Object.entries(data.response.insert).forEach(([idx, lineInsert]) => {
                        //console.log('Insert line in line #' + idx + ' data: ' + JSON.stringify(lineInsert));
                        state[repositoryName].splice(idx, 0, lineInsert);

                        if (lineInsert.line === 1) {
                            this.commit(module + '/addFeedLeague', {
                                line: lineInsert,
                                feedPrefix: feedPrefix,
                            });

                            if (!(lineInsert.cthId in state[feedTeam])) {
                                this.commit(module + '/addFeedTeam', {
                                    id: lineInsert.cthId,
                                    name: lineInsert.cthName,
                                    feedPrefix: feedPrefix,
                                });
                            }

                            if (!(lineInsert.ctaId in state[feedTeam])) {
                                this.commit(module + '/addFeedTeam', {
                                    id: lineInsert.ctaId,
                                    name: lineInsert.ctaName,
                                    feedPrefix: feedPrefix,
                                });
                            }
                        }
                    });
                }
            }
            if ('gamesIdx' in data.response) {
                state.gamesIdx[repositoryName] = data.response.gamesIdx;
            }
            if ('version' in data.response) {
                this.commit(
                    module + '/setVersion',
                    {
                        repositoryName: repositoryName,
                        version: data.response.version,
                    },
                    { root: true }
                );
                // state.version = data.response.version;
            }
        },
        setVersion(state, data) {
            state.version = data.version;
        },

        setLiveFeedTeam(state, feedTeam) {
            state.liveFeedTeam = feedTeam;
        },

        setLiveBotFeedTeam(state, feedTeam) {
            state.liveBotFeedTeam = feedTeam;
        },

        setTodayFeedTeam(state, feedTeam) {
            state.todayFeedTeam = feedTeam;
        },

        setEarlyFeedTeam(state, feedTeam) {
            state.earlyFeedTeam = feedTeam;
        },

        setLiveFeedLeague(state, feedLeague) {
            state.liveBotFeedLeague = feedLeague;
        },

        setLiveBotFeedLeague(state, feedLeague) {
            state.liveFeedLeague = feedLeague;
        },

        setTodayFeedLeague(state, feedLeague) {
            state.todayFeedLeague = feedLeague;
        },

        setEarlyFeedLeague(state, feedLeague) {
            state.earlyFeedLeague = feedLeague;
        },

        setExtraFeeds(state, extraFeeds) {
            state.extraFeeds = extraFeeds;
        },

        setCustomEventIdFilter(state, customEventId) {
            state.filters.customEventId = customEventId;
        },

        addFeedTeam(state, data) {
            let feedTeam = utils.lowerCaseFirstOnlyLetter(data.feedPrefix) + 'FeedTeam';

            let team = {
                id: data.id,
                name: data.name,
            };
            Vue.set(state[feedTeam], data.id, team);
        },

        removeFeedTeam(state, data) {
            let id = data.id;
            let feedTeam = utils.lowerCaseFirstOnlyLetter(data.feedPrefix) + 'FeedTeam';

            Vue.delete(state[feedTeam], id);
        },

        addFeedLeague(state, data) {
            let line = data.line;
            let feedLeague = utils.lowerCaseFirstOnlyLetter(data.feedPrefix) + 'FeedLeague';
            if (line.clId in state[feedLeague]) {
                let gCount = state[feedLeague][line.clId].gCount + 1;
                Vue.set(state[feedLeague][line.clId], 'gCount', gCount);
            } else {
                let league = {
                    id: line.clId,
                    name: line.clName,
                    iso3: line.iso3,
                    clLCId: line.clLCId,
                    clR: line.clR ?? 999, //a lowers priority, need for sorting when custom league rank is empty
                    gCount: 1,
                };
                Vue.set(state[feedLeague], line.clId, league);
            }
        },

        removeFeedLeague(state, data) {
            let clId = data.clId;
            let feedLeague = utils.lowerCaseFirstOnlyLetter(data.feedPrefix) + 'FeedLeague';

            if (state[feedLeague][clId] && state[feedLeague][clId].gCount > 1) {
                let gCount = state[feedLeague][clId].gCount - 1;
                Vue.set(state[feedLeague][clId], 'gCount', gCount);
            } else {
                Vue.delete(state[feedLeague], clId);
            }
        },
    };
};

export default feedMutations;
